import { useCampaignSlug } from '@/components/Functional/hooks-core/useCampaignSlug'

export const useLocalStorageClear = () => {
  const { campaignSlug, LOCAL_STORAGE_USER_DEVICE_UUID_KEY } = useCampaignSlug()
  return () => {
    const keysToRemove = Object.keys(localStorage).filter(
      (key) =>
        (key.startsWith(`${campaignSlug}-`) || key.startsWith(`${campaignSlug}_`)) &&
        key !== LOCAL_STORAGE_USER_DEVICE_UUID_KEY,
    )
    keysToRemove.forEach((key) => localStorage.removeItem(key))
  }
}
